import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { useTranslation } from 'react-i18next';
import { ActionButton, TitleComponent, MousePositionedTooltip } from '@keen.io/ui-core';
import { BodyText } from '@keen.io/typography';
import { colors } from '@keen.io/colors';
import FiltersComponent from './FiltersComponent';
import { ActionContainer, Wrapper, Container } from './Filters.styles';
import { getSchemas, getSchemaLoading } from '../../modules/events';
import { AppContext } from '../../contexts';

var Filters = function Filters(_ref) {
  var collection = _ref.collection,
      filters = _ref.filters,
      onReset = _ref.onReset,
      _onRemove = _ref.onRemove,
      _onChange = _ref.onChange,
      _onClick = _ref.onClick,
      funnelStepId = _ref.funnelStepId;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useContext = useContext(AppContext),
      modalContainer = _useContext.modalContainer;

  var isSchemaExist = useSelector(function (state) {
    var schemas = getSchemas(state);
    return schemas[collection];
  });
  var isSchemaLoading = useSelector(function (state) {
    return getSchemaLoading(state, collection);
  });

  var selectEventStreamTooltip = function selectEventStreamTooltip() {
    return React.createElement(BodyText, {
      variant: "body2",
      fontWeight: "normal",
      color: colors.white[500]
    }, t('query_creator_filters.select'), ' ', React.createElement("strong", null, t('query_creator_filters.event_stream')), ' ', t('query_creator_filters.tooltip'));
  };

  return React.createElement(Container, null, React.createElement(TitleComponent, {
    isDisabled: !collection
  }, t('query_creator_filters.filters')), React.createElement(Wrapper, {
    isDisabled: !collection
  }, isSchemaExist && !isSchemaLoading && React.createElement(FiltersComponent, {
    collection: collection,
    filters: filters,
    onReset: onReset && onReset,
    onRemove: function onRemove(id) {
      return _onRemove(id);
    },
    onChange: function onChange(id, filter) {
      return _onChange(id, filter);
    },
    funnelStepId: funnelStepId
  }), React.createElement(MousePositionedTooltip, {
    isActive: !collection,
    tooltipTheme: "dark",
    tooltipPortal: modalContainer,
    renderContent: selectEventStreamTooltip
  }, React.createElement(ActionContainer, {
    hasSpacing: !!filters.length
  }, React.createElement(ActionButton, {
    action: "create",
    isDisabled: !collection,
    onClick: function onClick() {
      var filterId = uuid();

      _onClick(filterId);
    }
  })))));
};

export default Filters;